import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

interface OtpHeaderProps {
  email?: string;
  isDisabled: boolean;
  onClose: () => void;
}

export const OtpHeader = ({ email, isDisabled, onClose }: OtpHeaderProps) => {
  if (!email) {
    return null;
  }

  return (
    <div className="bg-tertiary -mx-6 -mt-6 mb-4 flex h-14 items-center justify-between rounded-t-xl px-6">
      <Typography.BodySm color="text-slate-900 dark:text-inherit">
        {email}
      </Typography.BodySm>
      <button
        type="button"
        className="cursor-pointer text-slate-400 transition-colors hover:text-slate-600 dark:text-inherit"
        onClick={onClose}
        disabled={isDisabled}
        aria-label={t("close")}
        tabIndex={-1}
      >
        <Icon type="20-close" size={20} className="size-5" />
      </button>
    </div>
  );
};

OtpHeader.displayName = "OtpHeader";
